import type { WorldTheme } from './theme';

/**
 * United States sky of world 1: Miami (GDD §11.1, §14.2, issue #97). Turquoise and art-deco pink over a
 * pastel sky, with art-deco silhouettes and palms in the parallax. It is activated at the border crossing
 * (`border:crossed`) and keeps the collidable tints more saturated than the decoration (GDD §14.1).
 */

const MIAMI = {
  artDeco: 0x9fd6d0,
  artDecoSoft: 0xb9e2dc,
  building: 0xe6a9c4,
  buildingDark: 0xc98aa8,
  palm: 0x3f7f6a,
  palmDark: 0x2f6353,
  foreground: 0x2f6353,
} as const;

export const USA_MIAMI: WorldTheme = {
  id: 'usa-miami',
  variant: 'miami',
  sky: 0x8fd8e8,
  fog: { color: 0xa9e2ea, near: 40, far: 150 },
  ground: 0x5a8a7a,
  ceiling: 0xf2d9e6,
  collidable: { column: 0x1f8a2e, pickup: 0xe0a000 },
  lights: {
    hemisphere: { sky: 0xfff0e0, ground: 0x4a6a66, intensity: 1.1 },
    sun: { color: 0xfff4e0, intensity: 1.8, position: [-6, 14, 12] },
  },
  layers: [
    {
      name: 'layer.far',
      colors: [MIAMI.artDeco, MIAMI.artDecoSoft],
      moduleWidth: 22,
      height: 11,
      baseY: 1,
      motif: 'buildings',
    },
    {
      name: 'layer.mid',
      colors: [MIAMI.building, MIAMI.buildingDark, MIAMI.palm, MIAMI.palmDark],
      moduleWidth: 14,
      height: 6,
      baseY: 1,
      motif: 'buildings',
    },
    {
      name: 'layer.foreground',
      colors: [MIAMI.foreground],
      moduleWidth: 10,
      height: 1.4,
      baseY: -0.6,
      motif: 'foreground',
      followCamera: true,
    },
  ],
};
